import { ErrorHandler } from '@angular/core';

import { environment } from '@Environment/environment';

export class VineyardErrorHandler implements ErrorHandler {
  /**
   * バージョンアップ後のアプリには新しいハッシュ名のjsファイルがあるが、以前のバージョンのファイルをブラウザで読み込もうとする時のエラー
   */
  private readonly CHUNK_LOAD_ERROR = /ChunkLoadError/;

  constructor() {
    const originalConsoleError = console.error;
    // プロジェクト外（ライブラリなど）のエラーはhandleErrorでハンドリング出来ないため、console.errorの処理を上書きする
    // ⇒コンソールエラーを表示する際に、ChunkLoadErrorかどうかをチェックするようにする
    console.error = (...args) => {
      // オリジナルのconsole.errorを呼び出して既存の動作を保持
      originalConsoleError(...args);

      if (args.length > 0) {
        this.checkForChunkLoadError(args[0]);
      }
    };
  }

  handleError(error: any): void {
    this.checkForChunkLoadError(error);

    if (!environment.production) {
      console.error('ERROR', error);
    }
  }

  /**
   * 発生したエラーがCHUNK_LOAD_ERRORの場合、ページをリロードする
   */
  private checkForChunkLoadError(error: any): void {
    if (
      error instanceof Error &&
      (this.CHUNK_LOAD_ERROR.test(error.name) || // 外部からスローされた場合
        this.CHUNK_LOAD_ERROR.test(error.message)) // 内部で発生した場合
    ) {
      location.reload();
    }
  }
}
